<template>
    <div class="lang" v-bind:class="color">
        <a href="#" title="ENG" v-bind:class="[$language == 'en' ? 'active' : '']" @click="changeLanguage('en')">ENG</a><span>/</span>
        <a href="#" title="ESP" v-bind:class="[$language == 'es' ? 'active' : '']" @click="changeLanguage('es')">ESP</a><span>/</span>
        <a href="#" title="DEU" v-bind:class="[$language == 'de' ? 'active' : '']" @click="changeLanguage('de')">DEU</a>
    </div>
</template>

<script>
import i18n from '../../utils/i18n';

export default {
  name: 'lang-menu',
  props: ['color', '$language'],
  methods: {
    changeLanguage(lang) {
      i18n.setLocale(lang);
      location.reload();
    },
  },
};
</script>

<style lang="scss">

    .lang{
        font-family: $stack--heading;
        color: $c--black;
        font-size: $h--x-small;
        position: absolute;
        right: 4%;
        top: 40px;
        z-index: 999;

        a{
            color: $c--black;
            font-family: $stack--heading;
            text-decoration: none;
            margin-right: 4px;
            cursor: pointer;

            &:hover, &.active{
                text-decoration: underline;
            }
        }

        &.white{
            color: $c--white;

            a{
                color: $c--white;
            }
        }

        @include mq('phablet', 'max') {
            font-size: $h--xx-small;
            top: 22px;
        }

        @include mqlandscape(){
            font-size: $h--xx-small;
            top: 22px;
        }
    }    
</style>



// WEBPACK FOOTER //
// src/components/shared/LangMenu.vue